import { List } from "@mui/material";
import { Group } from "../../../api/representations";
import Card from "../../../components/card/Card";
import {
    groupListStyles,
    StyledGroupAvatar,
    StyledListItemAvatar,
    ViewAllButton,
    widgetCardContentStyles,
    widgetCardHeaderStyles
} from "../styles";
import { TFunction } from "i18next";
import ListRow from "../../../components/datalist/ListRow";
import { withDivider } from "../../../hoc/withDivider";
import { useNavigate } from "react-router-dom";
import { Spinner } from "@keycloak/keycloak-ui-shared";
interface DLGroupWidgetProps {
    t: TFunction;
    groups?: Group[];
    loading: boolean;
}

export default function DLGroupWidget({ t, groups, loading }: DLGroupWidgetProps) {
    const navigate = useNavigate();

    const groupTitle = `${t('groups')} ${groups?.length ? `| ${groups.length}`: ''}`;

    const action = groups?.length ? (
        <ViewAllButton component="button" onClick={() => navigate("groups")}>{t('viewAll')}</ViewAllButton>) : null;

    const shortGroups = groups?.slice(0, 3);    

    return (
        <Card title={groupTitle} action={action} sxContent={widgetCardContentStyles} sxHeader={widgetCardHeaderStyles}>
            { loading ?
                <Spinner /> :
                (<List sx={groupListStyles}>
                    {shortGroups?.map((group, index) => (
                        withDivider(ListRow)({
                            index,
                            items: shortGroups,
                            id: group.id,
                            text: group.name,
                            icon: (<StyledListItemAvatar>
                                <StyledGroupAvatar alt={group.name} src='/' />
                              </StyledListItemAvatar>
                        )})
                    ))}
                </List>)}
        </Card>
    );
}